import { AppDispatch } from "src/app/store";
import { setAuthInfo } from "src/features/authSlice";
import { HttpMethod, callApi } from "src/services/apiService";

/**
 * Refreshes the Redux auth state by fetching current user data from the server
 * @param dispatch - Redux dispatch function
 * @returns Promise<boolean> - Returns true if successful, false otherwise
 */
export const refreshAuthState = async (
  dispatch: AppDispatch,
): Promise<boolean> => {
  try {
    const apiUrl = "users/IsAuthenticated?data=true";
    const response = await callApi(apiUrl, HttpMethod.GET);

    if (
      response &&
      response.message?.toLowerCase() === "authorized" &&
      response.data
    ) {
      const data = response.data;

      dispatch(
        setAuthInfo({
          acctId: data.acctId || "",
          acctName: data.acctName || "",
          username: data.username || "",
          fullName: data.fullName || "",
          quickScrub: data.quickScrub || false,
          role: data.role?.toString() || "",
          isSysadmin: data.isSysadmin || false,
          hasSalesReportAccess: data.hasSalesReportAccess || false,
          loginId: data.loginId || "",
          csrfToken: data.csrfToken || "",
          hasTrainingFeature: data.hasTrainingFeature || false,
          homePage: data.homePage || "",
          landingPage: data.landingPage || "",
          acctMessage: data.acctMessage || "",
          userEmail: data.userEmail || "",
          isEmailVerified: data.isEmailVerified || false,
          isNXXG: data.isNXXG || false,
          // expiresAt lives at the top level of the IsAuthenticated response
          // (set by UsersController.IsAuthenticated on the ExpandoObject),
          // not inside response.data which is the AuthenticateResponse DTO.
          expiresAt: response.expiresAt ?? null,
        }),
      );

      return true;
    } else {
      return false;
    }
  } catch (error) {
    return false;
  }
};
